import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { useState, useEffect } from "react";

const permissionOptions = [
  {
    value: "admin:read",
    label: "Read",
    description: "View all data in the admin portal",
    alwaysChecked: true,
  },
  {
    value: "admin:write",
    label: "Write",
    description: "Edit applications, agreements, sailors, and other data",
  },
  {
    value: "admin:manage",
    label: "Manage",
    description: "Manage other admin users and their permissions",
  },
];

export const AdminPermissionsDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  initialPermissions = [],
}) => {
  const [selected, setSelected] = useState(["admin:read"]);

  useEffect(() => {
    if (open) {
      const perms =
        initialPermissions.length > 0 ? initialPermissions : ["admin:read"];
      setSelected([...new Set(["admin:read", ...perms])]);
    }
  }, [open, initialPermissions]);

  const handleToggle = (permission) => {
    setSelected((prev) =>
      prev.includes(permission)
        ? prev.filter((p) => p !== permission)
        : [...prev, permission]
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title || "Set Admin Permissions"}</DialogTitle>
      <DialogContent>
        <FormGroup>
          {permissionOptions.map((option) => (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  checked={selected.includes(option.value)}
                  onChange={() => handleToggle(option.value)}
                  disabled={option.alwaysChecked}
                />
              }
              label={`${option.label} — ${option.description}`}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={() => onConfirm(selected)}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
